module.exports = "<feed-post post=\"vm.post\" on-delete=\"vm.onDelete(post)\" is-expanded=\"true\"></feed-post>\n";